import React, { useEffect, useState } from "react";
import API from "../api/api";
import Swal from "sweetalert2";
import "./ManageAbout.css"; // ⭐ add new CSS file

export default function ManageAbout() {
  const [mainDescription, setMainDescription] = useState("");
  const [sections, setSections] = useState([]);

  useEffect(() => {
    loadData();
  }, []);

  const loadData = async () => {
    const res = await API.get("/about");
    if (res.data.data) {
      setMainDescription(res.data.data.mainDescription);
      setSections(res.data.data.sections);
    }
  };

  const addSection = () => {
    setSections([...sections, { heading: "", description: "" }]);
  };

  const updateSection = (index, field, value) => {
    const updated = [...sections];
    updated[index][field] = value;
    setSections(updated);
  };

  const deleteSection = (index) => {
    setSections(sections.filter((_, i) => i !== index));
  };

  const saveAbout = async () => {
    try {
      await API.put("/about", {
        mainDescription,
        sections,
      });

      Swal.fire({
        icon: "success",
        title: "About Us updated!",
        timer: 1500,
        showConfirmButton: false,
      });
    } catch (error) {
      Swal.fire("Error", "Failed to save", "error");
    }
  };

  return (
  <div className="latest-admin-wrapper">
    <div className="latest-admin-container shadow-lg">

      <h2 className="admin-title">Manage About Us</h2>
      <div className="underline"></div>

      {/* MAIN DESCRIPTION */}
      <div className="mb-4">
        <h5 className="sub-title">Main Description</h5>
        <textarea
          className="form-control textarea-main"
          rows="3"
          value={mainDescription}
          onChange={(e) => setMainDescription(e.target.value)}
        ></textarea>
      </div>

      {/* SECTIONS */}
      <h5 className="sub-title mb-3 mt-4">Sections</h5>

      <div className="row g-4">
  {sections.map((sec, i) => (
    <div key={i} className="col-12">
      <div className="section-card shadow-sm">

        <input
          type="text"
          className="form-control mb-2"
          placeholder="Section Heading"
          value={sec.heading}
          onChange={(e) =>
            updateSection(i, "heading", e.target.value)
          }
        />

        <textarea
          className="form-control"
          rows="3"
          placeholder="Section Description"
          value={sec.description}
          onChange={(e) =>
            updateSection(i, "description", e.target.value)
          }
        ></textarea>

        <div className="text-end mt-2">
          <button
            className="btn delete-btn"
            onClick={() => deleteSection(i)}
          >
            ✖ Remove
          </button>
        </div>
      </div>
    </div>
  ))}
</div>


      {/* ACTION BUTTONS */}
      <div className="mt-4 d-flex flex-wrap justify-content-between gap-2">
        <button className="btn add-btn" onClick={addSection}>
          + Add Section
        </button>

        <button className="btn save-btn px-4" onClick={saveAbout}>
          💾 Save Changes
        </button>
      </div>
    </div>
  </div>
);

}
